import {ISlideRuleModel} from "./slide-rule-model.interface";
import {ISlideRenderer} from "../../video-slides.service.interface";
import {IServiceFactory} from "../../../service-factory.interface";
import {PromotionSlideRenderer} from "../../video-slides-renderers/promotion-slide.renderer";

export class BannerSlideRuleModel implements ISlideRuleModel {

    constructor(private readonly services: IServiceFactory) {
    }

    appendToChunk(currentChunkContent: ISlideRenderer[]): ISlideRenderer[] {
        if(currentChunkContent.length > 0) {
            return [
                ...currentChunkContent,
                new PromotionSlideRenderer(this.services.tools.getGuid())
            ];
        }

        return currentChunkContent;

    }

}